export var ASPECT_RATIOS = {
  us: 27 / 40,
  fr: 3 / 4
};